import { render, staticRenderFns } from "./UpdateSnackbar.vue?vue&type=template&id=0151b7c1&"
import script from "./UpdateSnackbar.vue?vue&type=script&lang=ts&"
export * from "./UpdateSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports